import { Component } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';

const ModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9800;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: auto;
`;

const ModalCard = styled.div`
  border-radius: 1rem;
  padding: 1rem;
  z-index: 9900;
  width: ${p => (p.width ? p.width : '500px')};
  min-height: ${p => (p.height ? p.height : '300px')};
  max-height: 90vh;
  background-color: white;
  margin: 0 auto;
  align-self: center;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h6`
  margin: 0;
  color: red;
  font-size: 13px;
`;

const ModalBody = styled.div`
  margin: 0;
  margin-top: 1rem;
  margin-bottom: 1rem;
  flex-grow: 1;
`;

export default class ModalEmailLog extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return this.props.show ? (
      <ModalWrapper>
        <ModalCard width={this.props.width} height={this.props.height}>
          <ModalHeader>
            <ModalTitle>[Sent Email Log]</ModalTitle>
            <Button variant="text" size="small" style={{fontSize:'16px', maxWidth:'30px', maxHeight:'25px'}}
              onClick={this.props.onDecline}>
              X
            </Button>
          </ModalHeader>
          <ModalBody>
            {this.props.emailLog.map(logEntry => (
              <div key={logEntry.timestamp} className="mb-2" style={{ fontSize: '13px' }}>
                <b>{logEntry.timestamp}</b>
                <br />
                {logEntry.subject}
                <br />
                To:{' '}
                <span style={{ color: 'gray' }}>{logEntry.to || '---'}</span>
                <br />
                <hr />
              </div>
            ))}
          </ModalBody>
          <div className="modal-footer">
            <Button variant="contained" size="small"
              onClick={this.props.onDecline}>
              Close
            </Button>
          </div>
        </ModalCard>
      </ModalWrapper>
    ) : (
      <></>
    );
  }
}
